import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=735c77f1&scoped=true&"
import script from "./Step3.vue?vue&type=script&lang=js&"
export * from "./Step3.vue?vue&type=script&lang=js&"
import style0 from "./Step3.vue?vue&type=style&index=0&id=735c77f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c77f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735c77f1')) {
      api.createRecord('735c77f1', component.options)
    } else {
      api.reload('735c77f1', component.options)
    }
    module.hot.accept("./Step3.vue?vue&type=template&id=735c77f1&scoped=true&", function () {
      api.rerender('735c77f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/alteration/Step3.vue"
export default component.exports